export default {"src":"https://frontends.udemycdn.com/frontends-marketplace-experience/_next/static/media/marketing.26a6b109.svg","height":24,"width":24};